import React from 'react'
import BaseModal from '../BaseModal'
import './ErrorModal.css'
import { exclamation_icon } from '../../icons'

function ErrorModal(props) {
    return (
        <BaseModal show={props.show} title={props.title} buttonText={props.buttonText}
            onButtonClick={props.onButtonClick}
            icon={exclamation_icon}
            className='modal-error'>
            {props.children}
        </BaseModal>
    )
}

export default ErrorModal